import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../lib/axios";

const useFetchObjects = (
  queryKey,
  endpoint,
  options = {}
) => {
  const fetchFunction = async () => {
    try {
      const response = await axiosInstance.get(`/${endpoint}`);
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch data";
      throw new Error(Array.isArray(errorMessage) ? errorMessage.join(", ") : errorMessage);
    }
  };

  const { data, isLoading, isError, isSuccess, refetch, error } = useQuery({
    queryKey: queryKey,
    queryFn: fetchFunction,
    staleTime: options.staleTime ?? 5 * 60 * 1000, // 5 minutes default
    gcTime: options.gcTime ?? 10 * 60 * 1000, // 10 minutes default
    refetchOnWindowFocus: options.refetchOnWindowFocus ?? false,
    refetchInterval: options.refetchInterval ?? false,
    retry: options.retry ?? 1,
    retryDelay: options.retryDelay ?? 1000,
    enabled: options.enabled ?? true,
  });

  return {
    data,
    isLoading,
    isError,
    isSuccess,
    refetch,
    error
  };
};

export default useFetchObjects;